<script setup lang="ts">
const props = withDefaults(defineProps<{ value: number; size?: number; label?: string }>(), { size: 126, label: undefined })
const strokeWidth = 10
const radius = (props.size - strokeWidth) / 2
const circumference = 2 * Math.PI * radius
const offset = circumference * (1 - Math.min(100, Math.max(0, props.value)) / 100)
</script>

<template>
  <div class="ck-progress-ring" :style="{ width: `${size}px`, height: `${size}px` }">
    <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" role="img" :aria-label="label ?? `${value}% concluído`">
      <circle :cx="size / 2" :cy="size / 2" :r="radius" fill="none" stroke="var(--ck-cream-300)" :stroke-width="strokeWidth" />
      <circle
        :cx="size / 2" :cy="size / 2" :r="radius" fill="none" stroke="var(--ck-orange-500)" :stroke-width="strokeWidth"
        stroke-linecap="round" :stroke-dasharray="circumference" :stroke-dashoffset="offset"
        :transform="`rotate(-90 ${size / 2} ${size / 2})`"
      />
    </svg>
    <div class="value"><strong>{{ value }}%</strong><span>concluído</span></div>
  </div>
</template>

<style scoped>
.ck-progress-ring { position: relative; display: flex; align-items: center; justify-content: center; }
.value { position: absolute; display: flex; flex-direction: column; align-items: center; }
.value strong { font-family: var(--font-display); font-weight: 800; font-size: 22px; color: var(--ck-text); }
.value span { font-size: 10px; color: var(--ck-text-muted); }
circle { transition: stroke-dashoffset 260ms ease-out; }
@media (prefers-reduced-motion: reduce) { circle { transition: none; } }
</style>
